module.exports = __webpack_public_path__ + "img/ForwardingPage.04dd43fc.png";